import { render, staticRenderFns } from "./RedpackView.vue?vue&type=template&id=2706c1d0&scoped=true&"
import script from "./RedpackView.vue?vue&type=script&lang=js&"
export * from "./RedpackView.vue?vue&type=script&lang=js&"
import style0 from "./RedpackView.vue?vue&type=style&index=0&id=2706c1d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706c1d0",
  null
  
)

export default component.exports